import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "../queryKeys";
import { getModuleRepository } from "@/infrastructure/di";

export const useModuleEntitlements = (orgId: string) => {
  return useQuery({
    queryKey: queryKeys.modules.entitlements(orgId),
    queryFn: () => getModuleRepository().getEntitlements(),
    staleTime: 15 * 60 * 1000, // 15 min — entitlements rarely change
    enabled: !!orgId,
  });
};
